import React, { useState, useRef } from "react";
import { GetSchoolsForAdmin } from "../../actions/adminQueries";
import { Input, Button, Row, Col } from "reactstrap";
import { PacmanLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AddProgramLicenseToSchoolModal from "../../components/ProgramLicense/AddProgramLicenseToSchooModall";
import NumberOfLicenses from "../../components/ProgramLicense/NumberOfLicensesTable";
import { NumericFormat } from "react-number-format";
import LicensesDetails from "../../components/ProgramLicense/LicensesDetails";
import { FormattedMessage, useIntl } from "react-intl";
import { saveAs } from "file-saver";
import SuperuserSchoolEditModal from "../../components/Modal/SuperuserSchoolEditModal";
import CreateNewSchoolWizardModal from "../../components/Modal/CreateNewSchoolWizardModal";
import SchoolsTable from "./SchoolsTable";
import EditGroupsModal from "../../components/Modal/EditGroupsModal";

export default function SuperUser() {
  const intl = useIntl();
  const licenseDetailsRef = useRef(null);
  const [filterSearch, setFilterSearch] = useState("");
  const [addSchoolModal, setAddSchoolModal] = useState(false);
  const [overrideLoader, setOverrideLoader] = useState(false);
  const [schoolToUpdate, setSchoolToUpdate] = useState(null);
  const [licenseModalState, setLicenseModalState] = useState(false);
  const [currentSchool, setCurrentSchool] = useState(null);
  const [initialLicense, setInitialLicense] = useState(null);
  const [toggledLicenseDetails, setToggledLicenseDetails] = useState([]);
  const [editSchool, setEditSchool] = useState(false);
  const [editGroupsModalIsOpen, setEditGroupsModalIsOpen] = useState(false);

  const schoolInformation = GetSchoolsForAdmin();

  const toggleAddSchoolModal = (school) => {
    setOverrideLoader(true);
    setSchoolToUpdate(school);
    setAddSchoolModal((prev) => !prev);
  };

  const toggleEditSchoolModal = (school) => {
    setOverrideLoader(true);
    setSchoolToUpdate(school);
    setEditSchool((prev) => !prev);
  };

  const updateSchools = () => {
    schoolInformation.refetch();
    setAddSchoolModal(false);
  };

  const toggleProgramLicensesModal = (show, school, _unused, wasUpdated) => {
    setLicenseModalState(show);
    setCurrentSchool(school);
    setInitialLicense(null);
    if (wasUpdated) {
      schoolInformation.refetch();
    }
  };

  const openLicenseModalWithLicense = (school, license) => {
    setLicenseModalState(true);
    setCurrentSchool(school);
    setInitialLicense(license);
  };

  const toggleLicenseDetails = (detail, license) => {
    setToggledLicenseDetails([detail, license]);
    setTimeout(() => {
      if (licenseDetailsRef.current) {
        licenseDetailsRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 0);
  };

  const closeLicenseDetails = () => {
    setToggledLicenseDetails([]);
  };

  if (schoolInformation.isPending && !overrideLoader) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  const schoolResult = schoolInformation.data || {};
  var schools = schoolResult.schools || [];

  var fnSchoolsExcelReport = function () {
    const t = (id) => intl.formatMessage({ id });
    var tab_text =
      '<table><tr style="font-weight:bold">' +
      `<td>${t("CustomerNumber")}</td>` +
      `<td>${t("Name")}</td>` +
      `<td>${t("Address")}</td>` +
      `<td>${t("PostalCode")}</td>` +
      `<td>${t("City")}</td>` +
      `<td>${t("Country")}</td>` +
      `<td>${t("ProgramLicenses")}</td>` +
      `<td>${t("Program")}</td>` +
      `<td>${t("Navigation_Superuser_Classes")}</td>` +
      `<td>${t("Teachers")}</td>` +
      `<td>${t("Students")}</td>` +
      `<td>${t("ElLicense")}</td>` +
      `<td>${t("ConstructionLicense")}</td>` +
      `<td>${t("VehicleLicense")}</td>` +
      `<td>${t("StudentsEl")}</td>` +
      `<td>${t("StudentsConstruction")}</td>` +
      `<td>${t("StudentsVehicle")}</td>` +
      "</tr>";
    schools.map((s) => {
      return (tab_text +=
        "<tr>" +
        '<td style="text-align:left">' +
        s.fortKnoxCustomerNumber +
        '</td><td style="white-space:nowrap">' +
        s.name +
        '</td><td style="white-space:nowrap">' +
        s.adress.street +
        '</td><td style="text-align:left">' +
        s.adress.zipCode +
        "</td><td>" +
        s.adress.city +
        "</td><td>" +
        s.adress.country +
        '</td><td style="text-align:right">' +
        s.programLicenses.length +
        '</td><td style="text-align:right">' +
        s.programmes.length +
        '</td><td style="text-align:right">' +
        s.nbrOfClasses +
        '</td><td style="text-align:right">' +
        s.nbrOfTeachers +
        '</td><td style="text-align:right">' +
        s.nbrOfStudents +
        '</td><td style="text-align:center">&nbsp;' +
        s.licenseEl +
        '</td><td style="text-align:center">&nbsp;' +
        s.licenseBygg +
        '</td><td style="text-align:center">&nbsp;' +
        s.licenseFordon +
        '</td><td style="text-align:right">' +
        s.studenterEl +
        '</td><td style="text-align:right">' +
        s.studenterBygg +
        '</td><td style="text-align:right">' +
        s.studenterFordon +
        "</td></tr>");
    });
    tab_text = tab_text + "</table>";
    var data = new Blob(["\ufeff", tab_text], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      encoding: "utf-8",
    });
    saveAs(data, "Schools.xls");
  };

  if (filterSearch.length > 0) {
    schools = (schoolResult.schools || []).filter((school) => {
      if (
        school.name
          .toLowerCase()
          .indexOf(filterSearch.toLowerCase()) !== -1 ||
        school.fortKnoxCustomerNumber
          .toLowerCase()
          .indexOf(filterSearch.toLowerCase()) !== -1 ||
        school.fortNoxName
          .toLowerCase()
          .indexOf(filterSearch.toLowerCase()) !== -1 ||
        (school.adress.street != null &&
          school.adress.street
            .toLowerCase()
            .indexOf(filterSearch.toLowerCase()) !== -1) ||
        (school.adress.zipCode != null &&
          school.adress.zipCode
            .toLowerCase()
            .indexOf(filterSearch.toLowerCase()) !== -1) ||
        (school.adress.city != null &&
          school.adress.city
            .toLowerCase()
            .indexOf(filterSearch.toLowerCase()) !== -1) ||
        (school.group != null &&
          school.group.name
            .toLowerCase()
            .indexOf(filterSearch.toLowerCase()) !== -1)
      ) {
        return school;
      }
      return null;
    });
  }

  return (
    <div>
      <div className="card card-body">
        <h4>
          <FormattedMessage id="Navigation_Superuser_Schools" />
        </h4>
        <h6 className="text-muted mb-0">
          <FormattedMessage id="SchoolsTotal" />
          <NumericFormat
            value={schoolResult.quantitySchools}
            displayType={"text"}
            thousandSeparator={" "}
          />{" "}
          <FormattedMessage id="PiecesShort" />{" "}
          <FormattedMessage id="StudentsTotal" />
          <NumericFormat
            value={schoolResult.quantityStudents}
            displayType={"text"}
            thousandSeparator={" "}
          />{" "}
          <FormattedMessage id="PiecesShort" />
        </h6>
      </div>

      <div className="container-fluid admin-container pb-0">
        <NumberOfLicenses
          programLicenses={schoolResult.licenses}
          toggleLicenseDetails={toggleLicenseDetails}
        />
      </div>

      <div ref={licenseDetailsRef} style={{ scrollMarginTop: "40px" }}>
        <LicensesDetails
          closeDetails={closeLicenseDetails}
          showLicenseDetails={toggledLicenseDetails.length > 0}
          schools={schoolResult.schools}
          selectedLicenseDetail={toggledLicenseDetails}
          onSchoolClick={openLicenseModalWithLicense}
        />
      </div>

      <div className="container-fluid admin-container">
        <Row className="search-row">
          <Col className="col-3">
            <Input
              className="search-input"
              placeholder={intl.formatMessage({ id: "SearchSchool" })}
              onChange={(e) => setFilterSearch(e.target.value)}
            />
          </Col>
          <Col lg={6}>
            <Button
              className="me-2"
              color="primary"
              outline
              onClick={() => setEditGroupsModalIsOpen(true)}
            >
              <FormattedMessage id="EditGroups" />
            </Button>

            <Button
              className="me-2"
              color="primary"
              outline
              onClick={fnSchoolsExcelReport}
            >
              <FormattedMessage id="ExportToXls" />
            </Button>

            <Button
              color="primary"
              outline
              onClick={() => {
                toggleAddSchoolModal(null);
              }}
            >
              <FontAwesomeIcon icon="plus" />
            </Button>
          </Col>
        </Row>
        <SchoolsTable
          schools={schools}
          toggleEditSchoolModal={toggleEditSchoolModal}
          toggleProgramLicensesModal={toggleProgramLicensesModal}
        />
      </div>

      <CreateNewSchoolWizardModal
        toggle={() => toggleAddSchoolModal(null)}
        isOpen={addSchoolModal}
      />
      <SuperuserSchoolEditModal
        schoolToUpdate={schoolToUpdate}
        updateSchools={updateSchools}
        isOpen={editSchool}
        toggle={() => toggleEditSchoolModal(null)}
      />
      <AddProgramLicenseToSchoolModal
        key={currentSchool ? currentSchool.id : 0}
        isOpen={licenseModalState}
        toggle={toggleProgramLicensesModal}
        school={currentSchool}
        initialLicense={initialLicense}
      />
      <EditGroupsModal
        isOpen={editGroupsModalIsOpen}
        close={() => setEditGroupsModalIsOpen(false)}
        schools={schools}
      />
    </div>
  );
}
